import { useCallback } from 'react';

import { useGoTo } from 'common/hooks/useGoTo';
import { useCompanyId } from 'modules/app/hooks/useCompanyId';

export const useGoToBillingPage = () => {
  const goTo = useGoTo();
  const companyId = useCompanyId();

  return useCallback(
    () => goTo('COMPANY_BILLING_PLAN', { company: companyId }),
    [companyId],
  );
};
